program F1Bet;

uses
  Vcl.Forms,
  WEBLib.Forms,
  System.SysUtils,
  Unit3 in 'Unit3.pas'{*.html},
  uLogin in 'uLogin.pas'{*.html},
  uRegister in 'uRegister.pas'{*.html},
  uMain in 'uMain.pas'{*.html},
  uHttpHelper in 'uHttpHelper.pas',
  uStandings in 'uStandings.pas'{*.html},
  uAktuell in 'uAktuell.pas'{*.html},
  uAdmin in 'uAdmin.pas'{*.html},
  uDriverChoice in 'uDriverChoice.pas'{*.html},
  uHelper in 'uHelper.pas',
  uGlobal in 'uGlobal.pas',
  uGrandPrixTile in 'uGrandPrixTile.pas'{*.html},
  uSettings in 'uSettings.pas'{*.html},
  uDriverChoice2 in 'uDriverChoice2.pas'{*.html},
  uWMStand in 'uWMStand.pas'{*.html};

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;

  asm
    pas.uGlobal.TAppInfo.AppProject = window.ProjectName.split('_')[0];
    pas.uGlobal.TAppInfo.AppVersion = window.ProjectName.split('_').slice(1).join('.');
    //pas.uGlobal.TAppInfo.AppReleased = new luxon.DateTime.fromISO(new Date(document.lastModified).toISOString()).toFormat('yyyy-MMM-dd');
  end;
  TAppInfo.AppStarted := Now;

  Application.CreateForm(TfrmLogin, frmLogin);
  Application.CreateForm(TfrmDriverChoice2, frmDriverChoice2);
  Application.CreateForm(TfrmWMStand, frmWMStand);
  Application.Run;
end.
